import clsx from 'clsx';
import React, { ReactNode, createElement, useMemo } from 'react';

type TitleAndDescriptionProps = {
  className?: string;
  description?: ReactNode;
  title: ReactNode;
  compact?: boolean;
  testId?: string;
};

export const TitleAndDescription: React.FC<TitleAndDescriptionProps> = ({ description, title, className, compact, testId }) => {
  const descriptionElement = useMemo(() => {
    if (!description) return null;
    const props: Record<string, unknown> = { className: 'text-secondary mt-3 sm:text-lg' };

    // For legacy code
    if (typeof description === 'string') props.dangerouslySetInnerHTML = { __html: description };
    const children = typeof description === 'string' ? undefined : description;

    return createElement('p', props, children);
  }, [description]);

  const fontSize = compact ? 'text-lg sm:text-2xl' : 'text-xl sm:text-3xl';

  return (
    <div className={className} data-testid={testId}>
      <p className={clsx('text-default font-semibold', fontSize)}>{title}</p>
      {descriptionElement}
    </div>
  );
};
